export default "__VITE_ASSET__CgLXWvGV__"